<template>
    <div class="tsa-environmentCheck" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <!-- <svg-icon data_iconName="environment_ing" className="icon"></svg-icon> -->
            <img class="icon" src="@/assets/img/environment_ing.png" alt="">
            <p>{{ message }}</p>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            show: false,
            message: ''
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-environmentCheck {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 99999;
        .mask {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            background: rgba(0,0,0,0.5);
            z-index: 1;
        }
        .content {
            position: absolute;
            z-index: 2;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 220PX;
            height: 184PX;
            background: #FFFFFF;
            box-shadow: 0PX 4PX 12PX 1PX rgba(7,12,20,0.12);
            border-radius: 6PX;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            align-items: center;
            .icon  {
                font-size: 34PX;
                margin-top: 50PX;
                margin-bottom: 19PX;
            }
            p {
                font-weight: 400;
                font-size: 16PX;
                color: #000000;
                line-height: 22PX;
            }
        }
    }
</style>